"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = _interopRequireDefault(require("../../theme"));
const PlayButtonAsset = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: "68",
  height: "68",
  viewBox: "0 0 68 68",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "34",
  cy: "34",
  r: "34",
  fill: _theme.default.colors.reds[40]
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M24.2857 34.0002V48.5716L51 34.0001L24.2857 19.4287V34.0002Z",
  fill: _theme.default.colors.white
}));
const PlayButton = (0, _styledComponents.default)(PlayButtonAsset)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 10;
`;
var _default = exports.default = PlayButton;